export class CatalogoServicios {

    public id:number;
    public codigoConsorcio:string;
    public codigoServicio:string;
    public descripcionServicio:string;
    public costoEstandar:number;
    public codigoMoneda:string;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/catalogo-servicios.ts